import { GetExportedIntegrationsResponse, GetLightInvoicesResponse } from '@vy/api-definition';
import { netsuiteInvoiceActivitySelectors } from '@vy/app-selectors';
import { ItemOf } from '@vy/utils';
import { FC } from 'react';
import { Stack } from '@mui/material';
import { NetSuiteIntegrationStatusAccordion } from './Invoice-activity-erp-sync-tab-components/IntegrationStatusAccordion/NetSuiteIntegrationStatusAccordion';
import { NetSuiteInvoiceDetailsAccordion } from './Invoice-activity-erp-sync-tab-components/InvoiceDetailsAccordion/NetSuiteInvoiceDetailsAccordion';
import { ErpProductSettingsAccordion } from './Invoice-activity-erp-sync-tab-components/ErpProductSettingsAccordion/ErpProductSettingsAccordion';
import { VyDivider } from '../../../../../../../../../components/new-design/atoms';
import { INTEGRATION_TYPES, SYNC_JOB_STATUSES } from '@vy/integrations-types';

type InvoiceActivityNetSuiteSyncTabProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
  exportedInvoiceIntegrations: GetExportedIntegrationsResponse;
};

export const InvoiceActivityNetSuiteSyncTab: FC<InvoiceActivityNetSuiteSyncTabProps> = ({ invoice, exportedInvoiceIntegrations }) => {
  const netSuiteIntegration = findNetSuiteIntegration(exportedInvoiceIntegrations);
  const isSynced = netSuiteIntegration?.status === SYNC_JOB_STATUSES.COMPLETED;

  return (
    <Stack
      data-vy={netsuiteInvoiceActivitySelectors.tab}
      spacing="12px"
      sx={{
        height: 'calc(100vh - 400px)',
        overflowY: 'auto',
        scrollbarWidth: 'none',
      }}
      divider={<VyDivider />}
    >
      <NetSuiteIntegrationStatusAccordion netSuiteIntegration={netSuiteIntegration} invoice={invoice} />
      <NetSuiteInvoiceDetailsAccordion netSuiteIntegration={netSuiteIntegration} invoice={invoice} />
      <ErpProductSettingsAccordion invoiceId={invoice.id} customerId={invoice.customer.id} disabled={isSynced} />
    </Stack>
  );
};

function findNetSuiteIntegration(exportedInvoiceIntegrations: GetExportedIntegrationsResponse) {
  return exportedInvoiceIntegrations.find(
    (exportedIntegration) => exportedIntegration.integration === INTEGRATION_TYPES.NETSUITE,
  );
}
